"use client";

import React, { useContext } from "react";
import { useRouter } from "next/navigation";
import { Button as ButtonLib } from "@npm_leadtech/qr-ui-components";

import { Banner } from "@/components/Banner";
import { NextImage } from "@/components/NextImage";
import { Typography } from "@/components/Typography";
import { AmplitudeContext } from "@/contexts/AmplitudeContext/AmplitudeContext";

import { BannerWrapperSize } from "@/components/Banner/types";
import { analyticsBannerProps } from "@/data/types/home";

import "./styles.scss";

export const AnalyticsBannerModule = ({
  data,
  wrapperSize,
}: {
  data: analyticsBannerProps;
  wrapperSize?: BannerWrapperSize;
}) => {
  const {
    backgroundColor,
    ctaLabel,
    ctaLink,
    ctaIcon,
    data_qa,
    imageAlt,
    imageSrc,
    subtitle,
    title,
  } = data;

  const router = useRouter();
  const { setSource } = useContext(AmplitudeContext);

  const handleCtaClick = () => {
    setSource("cta_analytics_banner");
    router.push(ctaLink);
  };

  return (
    <Banner
      light
      noCenter
      customBgColor={backgroundColor}
      wrapperSize={wrapperSize}
      customClass="analytics-banner-module-banner"
    >
      <div
        className="analytics-banner-module"
        data-testid="analytics-banner-module"
      >
        <div className="analytics-banner-module__inner">
          <div className="analytics-banner-module__image">
            <NextImage
              src={imageSrc}
              width={1001}
              height={341}
              alt={imageAlt}
              loading="lazy"
              className="analytics-banner-module__image-el"
              size="(max-width: 940px) 100vw, 1001px"
            />
          </div>
          <div
            className="analytics-banner-module__gradient"
            aria-hidden="true"
          />
          <div className="analytics-banner-module__content">
            <div className="analytics-banner-module__information">
              <Typography
                Tag="h2"
                classname="analytics-banner-module__title u-spacing-0"
              >
                {title}
              </Typography>
              <Typography
                Tag="p"
                classname="analytics-banner-module__subtitle"
              >
                {subtitle}
              </Typography>
            </div>
            <div className="analytics-banner-module__cta">
              <ButtonLib
                dataQA={data_qa}
                onClick={handleCtaClick}
                label={ctaLabel}
                variant="secondary"
                iconRight={ctaIcon ? ctaIcon : undefined}
              />
            </div>
          </div>
        </div>
      </div>
    </Banner>
  );
};
